import CampaignStep from '@/components/lab/campaign-step/CampaignStep.vue';
import { Loading, storeGetters, NotFound } from '~';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  components: {
    NotFound,
    'campaign-step': CampaignStep,
    loading: Loading,
  },
  computed: {
    ...mapGetters('campaign', { campaign: 'currentCampaign' }),
    ...mapState('campaign', {
      loadingCampaign: 'loading',
      error: 'error',
    }),
    ...mapState('interests', {
      loadingInterests: 'loading',
    }),
    loading() {
      return this.loadingCampaign || this.loadingInterests;
    },
  },
  methods: {
    ...mapActions('campaign', ['getCampaign']),
    ...mapActions('interests', ['getInterests']),
    fetchData() {
      this.getCampaign(storeGetters.getRouterParams().code);
    },
  },
  mounted() {
    this.getInterests();
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route: 'fetchData',
  },
};



// WEBPACK FOOTER //
// ./src/components/lab/campaign/Campaign.js